import { Injectable, computed, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly loadingCount = signal(0);
  private readonly debouncedLoadingCount = signal(0);
  private debounceTimer: ReturnType<typeof setTimeout> | null = null;

  readonly isLoading = computed(() => this.debouncedLoadingCount() > 0);

  show(): void {
    this.loadingCount.update(count => count + 1);

    if (this.debounceTimer === null) {
      this.debounceTimer = setTimeout(() => {
        this.debouncedLoadingCount.set(this.loadingCount());
        this.debounceTimer = null;
      }, 100);
    }
  }

  hide(): void {
    this.loadingCount.update(count => Math.max(0, count - 1));

    if (this.loadingCount() === 0) {
      if (this.debounceTimer !== null) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
      this.debouncedLoadingCount.set(0);
    }
  }

  reset(): void {
    if (this.debounceTimer !== null) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
    this.loadingCount.set(0);
    this.debouncedLoadingCount.set(0);
  }
}
